import { Skeleton } from '@/shared/components/ui/skeleton';

export function TagsSectionSkeleton() {
  return (
    <div className="flex flex-wrap gap-2" aria-hidden="true" data-testid="tags-loading-skeleton">
      <Skeleton className="h-7 w-16 rounded-full" />
      <Skeleton className="h-7 w-24 rounded-full" />
      <Skeleton className="h-7 w-20 rounded-full" />
      <Skeleton className="h-7 w-28 rounded-full" />
      <Skeleton className="h-7 w-16 rounded-full" />
      <Skeleton className="h-7 w-32 rounded-full" />
      <Skeleton className="h-7 w-20 rounded-full" />
      <Skeleton className="h-7 w-24 rounded-full" />
    </div>
  );
}
